import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllFn = () => restHelpers.withBearer.get(`${K.API_URL}/fleet-managers`, {});

const createFn = objectData =>
  restHelpers.withBearer.post(`${K.API_URL}/fleet-managers`, {
    data: {
      name: objectData.name,
      surname: objectData.surname,
      companyName: objectData.companyName,
      email: objectData.email,
      pec: objectData.pec,
      mobile: objectData.mobile,
      phone: objectData.phone,
      address: objectData.address,
      uin: objectData.uin
    }
  });

const updateFn = (fleetManagerId, apiData) => restHelpers.withBearer.put(`${K.API_URL}/fleet-managers/${fleetManagerId}`, { data: { ...apiData } });

const getAvailableAssetsFn = () => restHelpers.withBearer.get(`${K.API_URL}/dealers/assets`, {});

const getFleetManagerAssetsFn = fleetManagerId => restHelpers.withBearer.get(`${K.API_URL}/dealers/fleet-managers/${fleetManagerId}/assets`, {});

const assignFleetManagerAssetsFn = (fleetManagerId, assetsIds) => restHelpers.withBearer.post(`${K.API_URL}/dealers/fleet-managers/${fleetManagerId}/assign-assets`, { data: { assets: assetsIds } });

const unassignFleetManagerAssetsFn = (fleetManagerId, assetsIds) => restHelpers.withBearer.post(`${K.API_URL}/dealers/fleet-managers/${fleetManagerId}/unassign-assets`, { data: { assets: assetsIds } });

export default {
  getAll: getAllFn,
  create: createFn,
  update: updateFn,

  getAvailableAssets: getAvailableAssetsFn,
  getFleetManagerAssets: getFleetManagerAssetsFn,
  assignFleetManagerAssets: assignFleetManagerAssetsFn,
  unassignFleetManagerAssets: unassignFleetManagerAssetsFn
};
